// client/src/components/tiposContrato/FiltroTipoContrato.js
import React, { useState } from 'react';
import { Search, XCircle as ClearIcon } from 'lucide-react';

const FiltroTiposContrato = ({ onFilterSubmit, loading }) => {
    const [filtro, setFiltro] = useState({
        nome: '',
        codigo: ''
    });

    const { nome, codigo } = filtro;

    const onChange = e => setFiltro({ ...filtro, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();
        const activeFilters = Object.fromEntries(Object.entries(filtro).filter(([_, v]) => v !== ''));
        onFilterSubmit(activeFilters);
    };

    const handleClear = () => {
        setFiltro({ nome: '', codigo: '' });
        onFilterSubmit({});
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <div className="form-grid-container">
                <div className="form-group">
                    <label htmlFor="filtro-nome">Nome do Tipo de Contrato</label>
                    <input type="text" id="filtro-nome" name="nome" placeholder="Buscar por nome..." value={nome} onChange={onChange} className="form-input" />
                </div>
                <div className="form-group">
                    <label htmlFor="filtro-codigo">Código</label>
                    <input type="text" id="filtro-codigo" name="codigo" placeholder="Buscar por código..." value={codigo} onChange={onChange} className="form-input" />
                </div>
            </div>
            <div className="form-actions">
                <button type="button" onClick={handleClear} className="action-button action-button-secondary" disabled={loading || (!nome && !codigo)}>
                    <ClearIcon size={18} className="icon"/> Limpar
                </button>
                <button type="submit" className="action-button action-button-primary" disabled={loading}>
                    <Search size={18} className="icon"/> Buscar
                </button>
            </div>
        </form>
    );
};

export default FiltroTiposContrato;